import { useQuery } from 'react-query';
import { findHotelConfig } from './api.config';

export const useAppConfigQuery = () => useQuery('hotels/config', findHotelConfig);
